import { dateHeureSuisse } from '../../lib/dates';
import { C } from '../../theme/palette';

/** La carte blanche de l'espace client. */
export const carte = {
  background: '#fff',
  borderRadius: 14,
  padding: 14,
  marginBottom: 10,
  boxShadow: '0 1px 3px rgba(0,0,0,.06)',
};

/**
 * @param {string} fond couleur du bouton
 * @param {boolean} [plein] bouton plein, sinon cerclé
 * @returns {object} le style d'un bouton de l'espace client
 */
export const bouton = (fond, plein = true) => ({
  border: plein ? 'none' : '1.5px solid ' + fond,
  background: plein ? fond : '#fff',
  color: plein ? '#fff' : fond,
  borderRadius: 12,
  padding: '12px 14px',
  minHeight: 44,
  fontSize: 14,
  fontWeight: 800,
  cursor: 'pointer',
  fontFamily: 'inherit',
});

/** Un champ de saisie de l'espace client. */
export const champ = {
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid ' + C.border,
  borderRadius: 11,
  padding: '11px 12px',
  minHeight: 44,
  fontSize: 15,
  fontFamily: 'inherit',
  background: '#fff',
  color: C.ink,
};

/** L'étiquette au-dessus d'un champ. */
export const etiquette = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: 12,
  fontWeight: 800,
  color: C.grey,
};

/** Le message d'erreur sous un formulaire. */
export const alerte = { color: C.red, fontWeight: 700, fontSize: 13, marginTop: 8 };

/** Le rôle d'une personne de l'entreprise cliente, en un mot. */
export const ROLES = {
  RESPONSABLE: 'Responsable',
  CHEF: 'Chef',
  EMPLOYE: 'Ouvrier',
};

/**
 * @param {string} [iso] date « 2026-10-08 »
 * @returns {string} « 08.10.2026 »
 */
export const dateCourte = (iso) =>
  iso ? String(iso).slice(0, 10).split('-').reverse().join('.') : '';

/**
 * @param {string} [instant] instant ISO
 * @returns {string} jour et heure suisses, « 04.11.2026 à 10:42 »
 */
export const jourEtHeure = (instant) => (instant ? dateHeureSuisse(instant) : '');

/**
 * @param {number|string} [q] quantité
 * @returns {number} la quantité, en nombre
 */
export const nombre = (q) => {
  const n = Number(q);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Ce qui reste à commander d'un article : son stock disponible, ou sans limite
 * quand le serveur ne le dit pas.
 *
 * @param {object} [article] article du catalogue
 * @returns {number} la quantité maximale
 */
export const stockDe = (article) =>
  article?.stock == null ? Infinity : Math.max(0, nombre(article.stock));

/**
 * @param {number} q quantité
 * @returns {number} la quantité arrondie au millième
 */
export const arrondi = (q) => Math.round(q * 1000) / 1000;
